module.exports = __webpack_public_path__ + "media/images/not_found-f8e908d5.svg";